
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"48","height":"48","rx":"24","fill":"url(#paint0_linear_33001_28535)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24 11.4c-6.948 0-12.6 5.652-12.6 12.6 0 6.947 5.652 12.6 12.6 12.6 6.948 0 12.6-5.653 12.6-12.6 0-6.948-5.652-12.6-12.6-12.6zm0 3.706a1.334 1.334 0 100-2.668 1.334 1.334 0 000 2.668zm1.334 19.122a1.334 1.334 0 11-2.668 0 1.334 1.334 0 012.668 0zM15.106 24a1.334 1.334 0 10-2.668 0 1.334 1.334 0 002.668 0zm19.122-1.334a1.334 1.334 0 110 2.668 1.334 1.334 0 010-2.668zm-10.665-.45c.274-.072.56-.081.835-.028.423-.27 1.623-1.16 3.004-2.182l1.13-.84c2.108-1.567 4.021-2.99 4.136-2.863.136.148-2.089 2.587-4.266 4.796-1.2 1.218-2.244 2.276-2.568 2.653a1.738 1.738 0 01-.598 1.47c-.75.65-1.895.59-2.56-.135a1.718 1.718 0 01-.403-1.58l-.519-.71c-1.03-1.406-2.657-3.626-2.493-3.774.159-.145 2.185 1.488 3.553 2.591.286.23.544.438.75.601z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_33001_28535","x1":"7","y1":"5","x2":"48","y2":"49","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#B52FB0"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FC79FF"}})])])])
          )
        }
      }
    